<template>
  <div>
    <div class="pa-4">

      <div class="d-flex justify-space-around mt-8 white--text success text-center pa-4 rounded-lg" v-if="getUser.admission.applicationType.screeningFee === 0">
        Screening fee not required. Check your dashboard and keep track of your status
      </div>
      <div class="rounded-lg my-2 mt-8 pa-4 text-center error white--text" v-else>
        Screening fee of &#8358;{{getAmount()}} is required.
      </div>
      <v-card-actions class="px-5 mb-4">
        <v-btn depressed color="primaryLight" width="30%" class="mt-4 white--text " @click="initializePayment" :disabled="(getScreeningFee != null && getScreeningFee.cleared) || loading">Pay now</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" width="30%" class="mt-4" @click="downloadInvoice">Download invoice</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="info" width="30%" :disabled="getUser.admission.applicationType.screeningFee < 0.1 || loading" class="mt-4" @click="downloadInvoice">Screening form</v-btn>
      </v-card-actions>
      <v-card-actions class="mt-8">
        <v-btn color="basic" class="white--text mr-4" width="10em" @click="$emit('back')" depressed>{{  noHeader ? 'Back' : "Previous" }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="info" depressed @click="success" width="10em" v-if="(getScreeningFee != null && getScreeningFee.cleared) || canSkip">Skip</v-btn>
      </v-card-actions>
      <loading-dialog :show="loading"></loading-dialog>
      <message-box :show="messageShow" :message="message" :type="messageType" v-on:close-message="messageShow = !messageShow"></message-box>
    </div>
  </div>
</template>

<script>
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import {mapGetters} from "vuex";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import {PaymentGateway} from "@/shared/PaymentGateway";
import GateWays from "@/shared/GateWays";
import Links from "@/shared/constants/Links";
import StudentStatus from "@/shared/StudentStatus";
import NumberUtils from "@/shared/NumberUtils";
export default {
  name: "ScreeningFee",
  props: {
    noHeader: Boolean
  },
  data: () => ({
    messageShow: false,
    loading: false,
    message: '',
    messageType: '',
    paymentGateway: null,
    paymentConfig: null,
  }),
  components: {MessageBox, LoadingDialog},

  methods: {
    success() {
      this.$emit("success")
    },

    notRequired(){
      return (this.getUser != null && this.getUser.admission.applicationType.screeningFee < 1)
    },

    initializePayment(){
      // initialize and get invoice
      this.loading = true
      Api.applicants.initializeScreeningTransaction(this.getUser.id)
          .then(res => {
            this.payment = res.data
            // show alert and make payment
            this.message = 'Initialized'
            this.messageType = 'success'
            this.messageShow = true
            this.makePayment()
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
    },

    downloadInvoice(){
      this.loading = true;
      Api.applicants.screeningInvoice(this.getUser.id)
          .then(res => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data], {type: 'application/pdf'}));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'invoice.pdf');
            document.body.appendChild(fileLink);

            fileLink.click();
            fileLink.remove();
          }).catch(() => {
          // ErrorReslover.checkErrors(this, err);
          this.message = "Failed to Download Invoice"
          this.messageType = "error"
          this.messageShow = true
      }).finally(() => this.loading = false)
    },

    check() {
      Api.applicants.nextToScreeningFee(this.getUser.id).then((res) => {
        this.loading = true;
          this.$store.commit("setCurrentUser", res.data);
          // this.success();
      }).catch((err) => ErrorResolver.checkErrors(this, err))
      .finally(() => this.loading = false )
    },

    getAmount(){
      if (this.getUser == null)
        return "00.0";
      return NumberUtils.format(this.getUser.admission.applicationType.screeningFee)
    },

    makePayment(){
      if(this.payment != null){
        if(this.paymentConfig.inline){
          this.paymentGateway.makePayment({
            email: this.getUser.email,
            amount: this.getUser.admission.applicationType.screeningFee,
            currency: 'NGN',
            invoice: this.payment.transactionId,
            paymentId: this.payment.id
          }, (data) => {
            window.location.reload()
          }, (invoice) => {
            // process
            this.loading = true
            Api.payment.processInline(invoice)
                .then(() => {
                  window.location.href = "/application"
                }).catch(err => {
              ErrorResolver.checkErrors(this, err)
              this.loading = false
            })
          })
        } else{
          // payment should not be done inline
          // open windwo for payment
          this.loading = true
          window.location.href = this.payment.paymentLink
        }
      }
    },
  },
  computed:{
    ...mapGetters(['getUser', 'getScreeningFee']),
    canSkip: function(){
      // status still not upto application complete
      return this.getUser != null && (StudentStatus[this.getUser.studentStatus].value > StudentStatus.SCREENING_PAYMENT_PENDING.value)
    }
  },

  watch: {
    getUser: function(val){
      if(val != null){
        if(this.notRequired())
          this.success()
      }
    },

    getScreeningFee: function(val){
      if(val != null){
        if(val.cleared)
          this.success()
      }
    }
  },

  mounted() {
    // initialize gateway
    this.$nextTick(() => {
      this.paymentGateway = new PaymentGateway(GateWays.REMITA, this, Links.payments.processInlinePayment)
      Api.paymentPlatforms.getActive()
          .then(res => {
            if(this.paymentGateway != null) {
              // set config
              this.paymentConfig = res.data
              // if inline, initialize
              if(res.data.inline)
                this.paymentGateway.initializeGateway(res.data)
            } else{
              this.message = 'No payment settings found'
              this.messageType = 'error'
              this.messageShow = true
            }
          }).catch(err => ErrorResolver.checkErrors(this, err))
    })
  },

  created() {

    // if application fee is not required, move to next
    if(this.notRequired()){
      this.success();
    } else{
      this.check();
    }

    this.noHeader && this.$emit('update-title', "Screening fee")
  }
}
</script>

<style scoped>
.v-text-field >>> .v-input__slot::before  { border-color: #ECBD44 !important; border-width: .01em; border-radius: .006em; }
</style>
